module.exports = __webpack_public_path__ + "img/DJI_0048(1).96f7adb8.jpg";